import { ModalCombinedType, ModalDialogProps, ModalDialogSizes, ModalDialogType } from '../ModalDialogTypes';
import ModalSize from '../ModalSize';
import ModalTypes from '../ModalTypes';

const mapModalType = (type?: ModalCombinedType): ModalDialogType | undefined => {
    if (!type) {
        return undefined;
    }
    switch (type) {
        // Found no uses of INFORMATION_SUCCESS -> so mapping it to standard
        case ModalTypes.INFORMATION_SUCCESS:
        case ModalTypes.STANDARD:
            return 'standard';
        case ModalTypes.SECONDARY:
            return 'sub';
        default:
            return type;
    }
};

const mapModalSize = (size?: ModalDialogSizes, modalSize?: ModalSize): ModalDialogSizes => {
    if (!size && !modalSize) {
        return 'medium';
    }

    if (modalSize && !size) {
        switch (modalSize) {
            case ModalSize.LARGE:
                return 'large';
            case ModalSize.WIDE:
                return 'wide';
            case ModalSize.MEDIUM:
            default:
                return 'medium';
        }
    }

    return size ?? 'medium';
};

type ModalDialogPropsWithOpen = {
    open: boolean;
} & Omit<ModalDialogProps, 'open'>;

const mapDeprecatedProps = (props: ModalDialogProps): ModalDialogPropsWithOpen => {
    const {
        type,
        open,
        size,
        modalSize,
        show,
        headerElements,
        headerContent,
        hideCloseButton,
        footerContent,
        footerClickableElements,
        ...rest
    } = props;

    return {
        type: mapModalType(type),
        size: mapModalSize(size, modalSize),
        open: show ?? open ?? false,
        headerContent: headerContent || headerElements,
        hideCloseButton: hideCloseButton ?? Boolean(headerElements) ?? false,
        footerContent: footerContent ?? footerClickableElements,
        ...rest,
    };
};

export default mapDeprecatedProps;
